/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneGuidanceV2ShowRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneGuidanceV2ShowRoute, {
  overrideRenderTemplate: false,
});
